import { useLocalSession } from 'auth/helpers/session.hooks';
import {
    CreateSalePropertyDto,
    MLNeighborhoodDto,
    PropertyPhotoDto,
    PublishListingDto,
    SaleListingDto,
    SalePropertyDto,
} from './sale.dto';
import { ApiSalesService } from './api-sales.service';

export interface SalesService {
    listSaleProperties(): Promise<SalePropertyDto[]>;
    getSaleProperty(propertyId: number): Promise<SalePropertyDto>;
    markForSale(propertyId: number, dto: CreateSalePropertyDto): Promise<SalePropertyDto>;
    updateSaleProperty(propertyId: number, dto: Partial<CreateSalePropertyDto>): Promise<SalePropertyDto>;
    removeFromSale(propertyId: number): Promise<void>;
    publishToML(propertyId: number, dto: PublishListingDto): Promise<SaleListingDto>;
    pauseListing(listingId: number): Promise<SaleListingDto>;
    closeListing(listingId: number): Promise<SaleListingDto>;
    syncListing(listingId: number): Promise<SaleListingDto>;
    getMLStatus(): Promise<{ url: string; connected: boolean }>;
    disconnectML(): Promise<void>;
    getMLStates(): Promise<MLNeighborhoodDto[]>;
    getMLCities(stateId: string): Promise<MLNeighborhoodDto[]>;
    getMLNeighborhoods(cityId: string): Promise<MLNeighborhoodDto[]>;
    getPropertyPhotos(propertyId: number): Promise<PropertyPhotoDto[]>;
    uploadPropertyPhoto(propertyId: number, file: File): Promise<PropertyPhotoDto>;
    deletePropertyPhoto(propertyId: number, photoId: number): Promise<void>;
}

export const useAPISalesService = (): SalesService => {
    const [getSession] = useLocalSession();
    const session = getSession();
    return new ApiSalesService(session);
};
